import { render, staticRenderFns } from "./InventoryBatchPaymentRequestHistoryAction.vue?vue&type=template&id=400c21c3&scoped=true"
import script from "./InventoryBatchPaymentRequestHistoryAction.vue?vue&type=script&lang=js"
export * from "./InventoryBatchPaymentRequestHistoryAction.vue?vue&type=script&lang=js"
import "./InventoryBatchPaymentRequestHistoryAction.vue?vue&type=style&index=0&id=400c21c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c21c3",
  null
  
)

export default component.exports